'use client';

import { isProduction } from '@magicschool/utils/nextjs/metadata';
import Script from 'next/script';
import { isCookieYesEnabled } from './isCookieYesEnabled';

export interface CookieYesClientProps {
  /** True for a student session (direct app or LTI) — CookieYes never loads at all for students. */
  isStudent?: boolean;
}

function CookieYesClient({ isStudent = false }: CookieYesClientProps) {
  if (isStudent) return null;

  if (!isCookieYesEnabled(isStudent)) {
    return (
      <div
        id="show-cookies" // @link https://nextjs.org/docs/app/building-your-application/optimizing/scripts#inline-scripts
        // biome-ignore lint/security/noDangerouslySetInnerHtml: Only happens in dev environments
        dangerouslySetInnerHTML={{
          __html: `<!-- <script src="https://cdn-cookieyes.com/client_data/643e0fb28246e9ffd93b5190/script.js"></script> -->`,
        }}
      />
    );
  }

  return isProduction() ? (
    <Script src="https://cdn-cookieyes.com/client_data/643e0fb28246e9ffd93b5190/script.js" />
  ) : (
    <Script src="https://cdn-cookieyes.com/client_data/1f5edd505856725fb63273ca/script.js" />
  );
}

export default CookieYesClient;
